import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {catchError, exhaustMap, map, of, switchMap} from "rxjs";
import {ItinerariesHttpService} from "../services/itineraries-http.service";
import {ItineraryModel} from "../models/itinerary.model";
import {ItinerariesActions, ItinerariesAPiActions, ItinerariesChannelActions} from "./itineraries.action";
import {ItinerariesChannelService} from "../services/itineraries-channel.service";

export const getItineraries = createEffect(
  (actions$ = inject(Actions),
   itinerariesHttpService: ItinerariesHttpService = inject(ItinerariesHttpService),
  ) => {
    return actions$.pipe(
      ofType(ItinerariesAPiActions.getItineraries),
      switchMap(payload => {
        return itinerariesHttpService.getItineraries(payload.ids).pipe(
          map((res: ItineraryModel[]) => ItinerariesAPiActions.getItinerariesSuccess({itineraries: res, isSubscribeToChannel: payload.isSubscribeToChannel})),
          catchError((error: { message: string }) => of(ItinerariesAPiActions.getItinerariesFailure({error}))),
        )
      })
    );
  },
  {functional: true}
);


export const getItinerariesSuccess = createEffect(
  (actions$ = inject(Actions),
   itinerariesChannelService = inject(ItinerariesChannelService)) => {
    return actions$.pipe(
      ofType(ItinerariesAPiActions.getItinerariesSuccess),
      map((payload) => {
        if (payload.isSubscribeToChannel) {
          const itineraryIds = payload.itineraries.map(i => i.id);
          itineraryIds.forEach(id => itinerariesChannelService.subscribeById(id));
        }
      })
    );
  },
  {functional: true, dispatch: false}
);


export const subscribeAllItineraryChannels = createEffect(
  (actions$ = inject(Actions),
   itinerariesChannelService = inject(ItinerariesChannelService)) => {
    return actions$.pipe(
      ofType(ItinerariesChannelActions.subscribe),
      switchMap(payload => {
        if (!!payload.ids) {
          payload.ids.forEach(id => itinerariesChannelService.subscribeById(id));
        }
        return itinerariesChannelService.getChannelsValues().pipe(
          map((notification: ItineraryModel) => ItinerariesChannelActions.notificationReceived({notification: notification}))
        )
      })
    );
  },
  {functional: true}
);


export const unsubscribeAllItineraryChannels = createEffect(
  (actions$ = inject(Actions),
   itinerariesChannelService = inject(ItinerariesChannelService)) => {
    return actions$.pipe(
      ofType(ItinerariesChannelActions.unsubscribe, ItinerariesActions.removeAll),
      map(payload => {
          itinerariesChannelService.unSubscribeAll();
          return ItinerariesChannelActions.unsubscribeSuccess();
        }
      )
    );
  },
  {functional: true}
);


export const unsubscribeItineraryChannelsByIds = createEffect(
  (actions$ = inject(Actions),
   itinerariesChannelService = inject(ItinerariesChannelService)) => {
    return actions$.pipe(
      ofType(ItinerariesActions.removeByIds),
      map(payload => {
          payload.ids.forEach((id) => {
            itinerariesChannelService.unSubscribeById(id);
          })
          return ItinerariesChannelActions.unsubscribeSuccess();
        }
      )
    );
  },
  {functional: true}
);
